import { call, put } from 'redux-saga/effects';

import { deleteMapping } from '@api/mapping';
import {
  conversionToolMappingsDeleteSuccess,
  conversionToolMappingsDeleteFailure,
} from '@store/conversionTool/conversionToolMappings/conversionToolMappings.actions';
import { toastError, toastSuccess } from '@store/notifications';

import { conversionToolMappingsFetchSaga } from '../conversionToolMappingsFetchSaga';

export const conversionToolMappingsDeleteSaga = function* ({ payload }) {
  try {
    const { id, entityJurisdictionId } = payload;
    yield call(deleteMapping, id);
    yield call(conversionToolMappingsFetchSaga, { payload: { entityJurisdictionId } });
    yield put([
      toastSuccess({
        message: {
          defaultMessage: 'Mapping deleted successfully.',
          id: 'components.mapping.delete.success',
        },
      }),
      conversionToolMappingsDeleteSuccess(payload),
    ]);
  } catch (errors) {
    const { nonFieldErrors, hasNonFieldError } = errors?.data || {};
    yield put([
      toastError({
        message: hasNonFieldError
          ? nonFieldErrors
          : {
              defaultMessage: 'Failed to delete the mapping.',
              id: 'global.notification.api-error-delete-conversion-tool-settings',
            },
      }),
      conversionToolMappingsDeleteFailure(),
    ]);
  }
};
